import { axios } from '../index'
let scopeUrl = null
let scope = scopeUrl ? `${scopeUrl}/central` : `/central`

export default {
  // 查看收入摊销
  checkIncomeAmortize: params =>
    axios.post(`${scope}/amortize-module/queryIncomeAmortize`, params),
  // 查看支出摊销
  checkPayAmortize: params =>
    axios.post(`${scope}/amortize-module/queryOutcomeAmortize`, params),
  // 查看支出摊销状态
  checkPayAmortizeStatus: params =>
    axios.post(`${scope}/amortize-module/queryOutcomeAmortizeStatus`, params),
  // 确认开始摊销
  confirmAmortize: params =>
    axios.post(`${scope}/amortize-module/confirmStartAmortize`, params),
  // 查看收支情况
  checkIncomeAndPay: params =>
    axios.post(`${scope}/amortize-module/queryBalanceOfPayment`, params),

  // 房东合同续租
  landlordContractRenew: params =>
    axios.post(`${scope}/contract-owner-module/renew`, params),
  // 房东合同退租
  landlordContractLeave: params =>
    axios.post(`${scope}/contract-owner-module/vacate`, params),
  // 查看房东合同列表
  checkLandlordList: params =>
    axios.post(`${scope}/contract-owner-module/contractList`, params),
  // 查看房东合同详情
  checkLandlordContractDetail: params =>
    axios.post(`${scope}/contract-owner-module/contractDetails`, params),

  // 删除密码
  deletePassword: params =>
    axios.post(`${scope}/lock-module/password/deletePassword`, params),
  // 查看密码
  checkPassword: params =>
    axios.post(`${scope}/lock-module/password/queryPassword`, params),
  // 解冻密码
  thawPassword: params =>
    axios.post(`${scope}/lock-module/password/unFrozePassword`, params),
  // 查看密码操作记录
  checkPasswordOperationRecord: params =>
    axios.post(`${scope}/lock-module/password/queryOperations`, params),
  // 冻结密码
  freezePassword: params =>
    axios.post(`${scope}/lock-module/password/frozePassword`, params),
  // 查看开门记录
  checkOpenDoorRecord: params =>
    axios.post(`${scope}/lock-module/password/queryDoorOpeningRecord`, params),
  // 发送离线密码
  sendOfflinePassword: params =>
    axios.post(`${scope}/lock-module/password/sendPasswordOffLine`, params),
  // 发送自定义密码
  sendCustomizePassword: params =>
    axios.post(`${scope}/lock-module/password/sendPasswordCustomized`, params),
  // 发送看房密码
  sendShowingPassword: params =>
    axios.post(`${scope}/lock-module/password/sendPasswordForShowings`, params),
  // 发送租客密码
  sendRenterPassword: params =>
    axios.post(`${scope}/lock-module/password/sendPasswordForTenant`, params),

  // 查询应收账单
  checkReceivableBill: params =>
    axios.post(`${scope}/payment-module/receivables/getReceivables`, params),
  // 查询应付账单
  checkShouldPayBill: params =>
    axios.post(`${scope}/payment-module/bills/getBills`, params),
  // 查询应付账单详情
  checkShouldPayBillDetail: params =>
    axios.post(`${scope}/payment-module/bills/getBillsDetails`, params),
  // 查询应收账单详情
  checkReceivableBillDetail: params =>
    axios.post(
      `${scope}/payment-module/receivables/getReceivableDetails`, params
    ),
  // 应付账单申请付款
  applyForPay: params =>
    axios.post(`${scope}/payment-module/bills/applyBillsPayment`, params),
  // 应付账单取消
  cancelBillsOfShouldPay: params =>
    axios.post(`${scope}/payment-module/bills/cancelBillsPayment`, params),
  // 应付账单打款
  giveMoneyForShouldPay: params =>
    axios.post(`${scope}/payment-module/bills/remitBillsPayment`, params),
  // 应付账单改期
  changeDateForShouldPay: params =>
    axios.post(`${scope}/payment-module/bills/unburdenBillsPayment`, params),

  // 管家绩效数据导出
  stewardPerformanceDataExport: params =>
    axios.post(
      `${scope}/performance-module/exportHouseKeeperPerformance`,
      params
    ),
  // 店长绩效数据导出
  managerPerformanceDataExport: params =>
    axios.post(`${scope}/performance-module/exportManagerPerformance`, params),
  // 查看店长绩效详情
  checkManagerPerformanceDetail: params =>
    axios.post(
      `${scope}/performance-module/queryManagerPerformanceDetail`,
      params
    ),
  // 查看管家绩效详情
  checkStewardPerformanceDetail: params =>
    axios.post(
      `${scope}/performance-module/queryHouseKeeperPerformanceDetail`,
      params
    ),
  // 查看管家绩效
  checkStewardPerformance: params =>
    axios.post(
      `${scope}/performance-module/queryHouseKeeperPerformance`,
      params
    ),
  // 编辑店长态度能力分数
  editManagerAbilityGrade: params =>
    axios.post(`${scope}/performance-module/editManagerAbilityScore`, params),
  // 编辑管家态度能力分数
  editStewardAbilityGrade: params =>
    axios.post(
      `${scope}/performance-module/editHouseKeeperAbilityScore`,
      params
    ),
  // 查看店长绩效
  checkManagerPerformance: params =>
    axios.post(`${scope}/performance-module/queryManagerPerformance`, params),
  // 编辑店长稽核分数
  editManagerAuditGrade: params =>
    axios.post(`${scope}/performance-module/editManagerInspectScore`, params),
  // 管家绩效数据导出
  exportHouseKeeperPerformance: params =>
    axios.post(
      `${scope}/performance-module/exportHouseKeeperPerformance`,
      params
    ),
  // 店长绩效数据导出
  exportManagerPerformance: params =>
    axios.post(`${scope}/performance-module/exportManagerPerformance`, params),
  // 查看店长绩效详情
  queryManagerPerformanceDetail: params =>
    axios.post(
      `${scope}/performance-module/queryManagerPerformanceDetail`,
      params
    ),
  // 查看管家绩效详情
  queryHouseKeeperPerformanceDetail: params =>
    axios.post(
      `${scope}/performance-module/queryHouseKeeperPerformanceDetail`,
      params
    ),
  // 录入优惠
  enterExpenses: params =>
    axios.post(`${scope}/rent-management-module/enterCoupon`, params),
  // 修改预定保留天数
  changeKeepDays: params =>
    axios.post(`${scope}/reserve-module/modifyValidity`, params),

  // 申请删改房东账单
  applyForEditLordPayment: params =>
    axios.post(`${scope}/payment-module/applyForEditLordPayment`, params),
  // 修改银行信息
  modifyBankInformation: params =>
    axios.post(`${scope}/contract-owner-module/modifyBankInformation`, params),
  // 添加同住人
  addCohabitant: params =>
    axios.post(`${scope}/contract-tenant-module/addCohabitant`, params),
  // 搬出同住人
  moveCohabitant: params =>
    axios.post(`${scope}/contract-tenant-module/moveCohabitant`, params),
  // 添加入住人
  addMainTenant: params =>
    axios.post(`${scope}/contract-tenant-module/addMainTenant`, params),
  // 搬出入住人
  moveMainTenant: params =>
    axios.post(`${scope}/contract-tenant-module/moveMainTenant`, params),

  // 申请修改手机号
  applyForModifyTel: params =>
    axios.post(`${scope}/tenant-module/applyForModifyTel`, params),
  // 申请删除定金
  applyForDelDeposit: params =>
    axios.post(`${scope}/contract-tenant-module/applyForDelDeposit`, params),
  // 申请取消新签合同
  applyForCancelingNew: params =>
    axios.post(`${scope}/contract-tenant-module/applyForCancelingNew`, params),
  // 申请取消续租合同
  applyForCancelingRenew: params =>
    axios.post(
      `${scope}/contract-tenant-module/applyForCancelingRenew`,
      params
    ),

  // 新增房东合同
  addNewLandlordContract: params =>
    axios.post(`${scope}/contract-owner-module/add`, params),
  // 录入其他类型的房源
  enterOtherHousing: params =>
    axios.post(`${scope}/housing-module/enterOtherHousing`, params),
  // 冻结房源状态
  freezeHousing: params =>
    axios.post(`${scope}/housing-module/freezeHousing`, params),
  // 解冻房源状态
  unfreezeHousing: params =>
    axios.post(`${scope}/housing-module/unfreezeHousing`, params),
  // 导出空调数据(项目用量)
  airConditioningDataExportByZone: params =>
    axios.post(
      `${scope}/energy-module/airConditioningDataExportByZone`,
      params
    ),
  // 导出空调数据(单个房源)
  airConditioningDataExportByHouse: params =>
    axios.post(
      `${scope}/energy-module/airConditioningDataExportByHouse`,
      params
    ),
  // 申请拆分账单
  applyForSplit: params =>
    axios.post(`${scope}/payment-module/applyForSplit`, params),
  // 申请删改账单
  applyForEdit: params =>
    axios.post(`${scope}/payment-module/applyForEdit`, params),
  // 确认收款
  confirmBills: params => axios.post(`${scope}/payment-module/confirm`, params),
  // 改回未支付
  rollBackUnpaid: params =>
    axios.post(`${scope}/payment-module/rollBackUnpaid`, params),
  // 错误款项打回
  payBackWrongBill: params =>
    axios.post(`${scope}/payment-module/payBack`, params),
  // 申请批量付款
  applyForBulkPayment: params =>
    axios.post(`${scope}/payment-module/applyForBulkPayment`, params),
  // 已打款改为打款失败(退款)
  refundBill: params => axios.post(`${scope}/payment-module/refund`, params),
  // 打款失败改为已打款(打款)
  makeAPayment: params =>
    axios.post(`${scope}/payment-module/makeAPayment`, params),
  // 账单提前生成
  billAdvanceCreated: params =>
    axios.post(
      `${scope}/rent-management-module/applyBillGenerationInAdvance`,
      params
    ),

  // 整合类接口
  // 查询全部摊销数据 的列表接口
  getIncomeAmortizeAll: (type, params) =>
    type === 'INCOME'
      ? axios.post(`${scope}/amortize-module/queryIncomeAmortize`, params)
      : axios.post(`${scope}/amortize-module/queryOutcomeAmortize`, params),
  // 发送门锁密码
  sendLockPassword: (type, params) =>
    type === 'NORMAL'
      ? axios.post(
          `${scope}/lock-module/password/sendPasswordForTenant`,
          params
        )
      : type === 'TEMP'
      ? axios.post(
          `${scope}/lock-module/password/sendPasswordForShowings`,
          params
        )
      : type === 'CUSTOM'
      ? axios.post(
          `${scope}/lock-module/password/sendPasswordCustomized`,
          params
        )
      : axios.post(`${scope}/lock-module/password/sendPasswordOffLine`, params),
  // 查看 管家绩效和店长绩效
  getPerformance: (type, params) =>
    type === 'SHOPOWNER'
      ? axios.post(
          `${scope}/performance-module/queryManagerPerformance`,
          params
        )
      : axios.post(
          `${scope}/performance-module/queryHouseKeeperPerformance`,
          params
        ),
  // 更新管家\店长绩效
  updatePerformance: (type, params) =>
    type === 'SHOPOWNER'
      ? axios.post(
          `${scope}/performance-module/editManagerAbilityScore`,
          params
        )
      : axios.post(
          `${scope}/performance-module/editHouseKeeperAbilityScore`,
          params
        ),
  // 添加入住人和同住人
  addRenter: (type, params) =>
    type === 'STAYIN'
      ? axios.post(`${scope}/contract-tenant-module/addMainTenant`, params)
      : axios.post(`${scope}/contract-tenant-module/addCohabitantInfo`, params),
  // 搬出入住人和同住人
  moveOutRenter: (type, params) =>
    type === 'FOLLOW'
      ? axios.post(`${scope}/contract-tenant-module/moveCohabitant`, params)
      : axios.post(`${scope}/contract-tenant-module/moveMainTenant`, params),
  // 导出空调用量数据 项目用量报表和单个房源用量
  exportAirConditionInform: (type, params) =>
    type === 'getAirUseInfoByZone'
      ? axios.post(
          `${scope}/energy-module/airConditioningDataExportByZone`,
          params
        )
      : axios.post(
          `${scope}/energy-module/airConditioningDataExportByHouse`,
          params
        ),
  // 房东合同的新签和续租接口整合
  newAndRenewLandlordContract: (type, params) =>
    type
      ? axios.post(`${scope}/contract-owner-module/renew`, params)
      : axios.post(`${scope}/contract-owner-module/add`, params),
  // 根据职位导出对应绩效数据
  exportPerformanceByPosition: (type, params) =>
    type === 'SHOPOWNER'
      ? axios.post(
          `${scope}/performance-module/exportManagerPerformance`,
          params
        )
      : axios.post(
          `${scope}/performance-module/exportHouseKeeperPerformance`,
          params
        ),
  // 根据职位获取对应的绩效详情
  getDetailByPosition: (type, params) =>
    type === 'SHOPOWNER'
      ? axios.post(
          `${scope}/performance-module/queryManagerPerformanceDetail`,
          params
        )
      : axios.post(
          `${scope}/performance-module/queryHouseKeeperPerformanceDetail`,
          params
        ),
  // 账单 改回未支付和错误款项打回
  rollBackBill: (type, params) =>
    type === 'operate'
      ? axios.post(`${scope}/payment-module/rollBackUnpaid`, params)
      : axios.post(`${scope}/payment-module/payBack`, params),
  // 应收账单 收款和更改账单状态
  billConfirmReceived: (params) => axios.post(`${scope}/payment-module/confirmReceived`, params),
  // 获取(管家、店长)绩效列表
  getPerformanceList: (type, params) => type === 'HOUSEKEEPER' ? axios.post(`${scope}/performance-module/getListForHousekeeper`, params) : axios.post(`${scope}/performance-module/getListForShopOwner`, params),
  //  详情列表(新)
  getPerformanceDetailByType: (type, params) => type === 'HOUSEKEEPER' ? axios.post(`${scope}/performance-module/getHouseKeeperDetail`, params) : axios.post(`${scope}/performance-module/getShopOwnerDetail`, params),
  // 绩效导出（新）
  exportNewPerformance: (type, params) => type === 'HOUSEKEEPER' ? axios.post(`${scope}/performance-module/exportHouseKeeper`, params) : axios.post(`${scope}/performance-module/exportShopowner`, params),
  // 编辑态度能力和有效投诉数
  editAbilityAndEffectiveComplain: (type, params) => type === 'HOUSEKEEPER' ? axios.post(`${scope}/performance-module/updatePersonalPerformanceForHouseKeeper`, params) : axios.post(`${scope}/performance-module/updatePersonalPerformanceForShopOwner`, params),
// 房源上线配置
  HouseResConfig: params =>
  axios.post(`${scope}/basic-module/addZoneAndBlock`, params),

}



// WEBPACK FOOTER //
// ./src/xhr/services/central.js